import { css } from '@emotion/css';

export const footerFluid = css`
  width: 100%;
  max-width: 1280px;
  margin: auto;
  padding: 40px 15px 10px;
  align-self: end;
`;

export const footerLogo = css``;

export const socialIcon = css`
  display: flex;
  margin-top: 15px;
  a {
    display: inline-block;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

export const footerFlex = css`
  display: flex;
  justify-content: space-evenly;

  @media (max-width: 992px) {
    flex-wrap: wrap;
  }
`;

export const footerCols = css`
  h3 {
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 700;
    margin: 0;
    margin-bottom: 41px;
    margin-top: 25px;
    @media (max-width: 767px) {
      margin-bottom: 15px;
    }
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    li {
      list-style-type: none;
      a {
        display: block;
        margin-bottom: 7px;
        font-size: 14px;
        &:hover {
          color: #f16602;
        }
      }
    }
  }
`;

export const footerBox = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 15px;
  padding-right: 60px;
  @media (max-width: 767px) {
    padding-right: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
  p {
    font-size: 14px;
    margin-top: 0;
  }
  small {
    font-size: 12px;
    color: #818181;
    display: block;
    width: 100%;
    margin-left: 75px;
    margin-top: -13px;
  }
`;

export const footerBoxFlex = css`
  display: flex;
  align-items: center;
`;

export const footerBoxImg = css`
  min-width: 60px;
  height: 60px;
  background: #ebebeb;
  border-radius: 5px;
  margin-right: 15px;
`;

export const colmd3 = css`
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
  p {
    padding-right: 30px;
    font-size: 14px;
    @media (max-width: 767px) {
      padding-right: 0;
    }
  }
  @media (max-width: 992px) {
    flex: 0 0 50%;
    max-width: 50%;
    @media (max-width: 767px) {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;

export const colmd2 = css`
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.666667%;
  flex: 0 0 16.666667%;
  max-width: 16.666667%;
  @media (max-width: 992px) {
    flex: 0 0 50%;
    max-width: 50%;
    @media (max-width: 767px) {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;

export const colmd4 = css`
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.333333%;
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
  @media (max-width: 992px) {
    flex: 0 0 50%;
    max-width: 50%;
    @media (max-width: 767px) {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;

export const footerContact = css`
  li {
    list-style-type: none;
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      display: inline-block;
      margin-right: 10px;
    }
    a:hover {
      color: blue;
    }
  }
`;

export const copyright = css`
  text-align: center;
  width: 100%;
  font-size: 12px;
  padding-top: 50px;
`;
